<section class="pricing-details-section" *ngIf="pricingDetailContent && pricingDetailContent.pricingDetailActive">
    <div class="box">
        <h2 id="pricingDetailsSection" class="sub-heading" [innerHTML]="pricingDetailContent?.heading"></h2>
        <div class="content" [innerHTML]="pricingDetailContent?.description | safeHtml"></div>
        <div class="additonal-links">
            <!-- <a *ngFor="let additionalLink of pricingDetailContent?.additionalLinks" target="_blank" rel="noopener"
            [href]="additionalLink.link" role="link" cdsButton="inlineLink" [innerHTML]="additionalLink.name"></a> -->

            <span *ngFor="let additionalLink of pricingDetailContent?.additionalLinks">
                <a role="link"
                    *ngIf="additionalLink.linkType != 'additionalInfo' && additionalLink?.name"
                    target="_blank" rel="noopener"
                    [href]="additionalLink.link"
                    cdsButton="inlineLink"
                    [innerHTML]="additionalLink.name"
                    (click)="pricingInfo('pricingInfoLinkBody')"
                ></a>
                <a
                    *ngIf="additionalLink.linkType == 'additionalInfo' && additionalLink?.name"
                    role="link"
                    tabindex="0"
                    (click)="navigateToAdditionalInfoPage($event)"
                    (keyup.Enter)="navigateToAdditionalInfoPage($event)"
                    cdsButton="inlineLink"
                    [innerHTML]="additionalLink.name"
                    (click)="pricingInfo('additionalInfoLinkBody'); additionalInfo($event)"
                ></a>
            </span>
        </div>
    </div>
</section>
